if (!customElements.get('flagship-devices')) {
  customElements.define(
    'flagship-devices',
    class FlagshipDevices extends HTMLElement {
      constructor() {
        super()
        let swiper
        const _this = this
        function getCollectionDetails() {
          let swiper = this

          let slideTitle = swiper.slides[swiper.activeIndex].getAttribute('data-title')
          let accordionTitle = swiper.slides[swiper.activeIndex].getAttribute('data-accordion').trim()
          let previousTitle = swiper.slides[swiper.previousIndex].getAttribute('data-title')

          const accordions = _this.getElementsByClassName('accordion-title')
          for (let i = 0; i < accordions.length; i++) {
            if (accordions[i].innerHTML.trim() == accordionTitle) {
              gsap.set('#active-accordion-' + (i + 1), {
                display: 'block',
              })
              gsap.fromTo(
                '#active-accordion-' + (i + 1),
                {
                  autoAlpha: 0,
                },
                {
                  autoAlpha: 1,
                  duration: 1,
                },
              )
            } else {
              gsap.to('#active-accordion-' + (i + 1), {
                autoAlpha: 0,
                duration: 1,
              })
              gsap.set('#active-accordion-' + (i + 1), {
                display: 'none',
              })
            }
          }
          const infoSections = _this.getElementsByClassName('second-section')
          for (let i = 0; i < infoSections.length; i++) {
            if (
              infoSections[i].firstElementChild.innerHTML == previousTitle &&
              infoSections[i].firstElementChild.innerHTML != slideTitle
            ) {
              gsap.to(infoSections[i], {
                autoAlpha: 0,
                duration: 1,
              })
              gsap.set(infoSections[i], {
                display: 'none',
                className: 'm-0 overflow-hidden opacity-0 hidden second-section',
              })
            }
            if (infoSections[i].firstElementChild.innerHTML == slideTitle) {
              gsap.set(infoSections[i], {
                display: 'block',
                className: 'active-section m-0 overflow-hidden opacity-0 hidden second-section',
              })
              gsap.fromTo(
                '.active-section',
                {
                  autoAlpha: 0,
                },
                {
                  autoAlpha: 1,
                  duration: 1,
                },
              )
            }
          }
        }
        window.addEventListener('DOMContentLoaded', () => {
          swiper = new Swiper(this.querySelector('.flagship-devices-slider'), {
            pagination: {
              el: '.flagship-devices .swiper-pagination',
              type: 'fraction',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            loop: true,
            slideToClickedSlide: true,
            centeredSlides: true,
            speed: 500,
            spaceBetween: 0,
            watchSlidesProgress: true,
            virtualTranslate: false,
            on: {
              slideChangeTransitionStart: getCollectionDetails,
              init: getCollectionDetails,
            },
            breakpoints: {
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
              },
              480: {
                slidesPerView: 2.5,
              },
              990: {
                slidesPerView: 4.5,
              },
              1020: {
                slidesPerView: 6.5,
              },
              1536: {
                slidesPerView: 6.5,
                spaceBetween: 20,
              },
              2500: {
                slidesPerView: 9,
                spaceBetween: 40,
              },
            },
          })
          const accordions = this.getElementsByClassName('slider-accordion')
          for (const accordion of accordions) {
            accordion.addEventListener('click', (e) => {
              const target = e.target.classList.contains('accordion-section')
                ? e.target
                : e.target.closest('.accordion-section')
              if (target.children.item(0).children.item(0).innerHTML != 'hidden') {
                const dropDowns = target.getElementsByClassName('drop-down-section')
                const arrow = target.children.item(0).children.item(1)
                for (const dropDown of dropDowns) {
                  if (dropDown.style.maxHeight != '0px') {
                    gsap.to(dropDown, {
                      maxHeight: '0px',
                      autoAlpha: 0,
                      duration: 0.1,
                    })
                    gsap.set(arrow, {
                      className: 'down-arrow open my-auto',
                    })
                  } else {
                    gsap.to(dropDown, {
                      maxHeight: 1000,
                      autoAlpha: 1,
                      duration: 0.1,
                    })
                    gsap.set(arrow, {
                      className: 'down-arrow my-auto',
                    })
                  }
                }
              }
            })
          }
          const products = this.querySelectorAll('.flagship-devices .accordion-card.hover')
          products.forEach((product) => {
            const image = product.querySelector('.main-image')
            const imageHover = product.querySelector('.image-hover')
            const videoHover = product.querySelector('.video-hover')
            const icon = product.querySelector('.icon-arrow-right-long-regular')
            product.addEventListener('mouseover', () => {
              product.classList.add('text-white')
              image.classList.add('block')
              icon.classList.remove('hidden', 'opacity-0')
              imageHover?.classList.remove('invisible', 'opacity-0')
              imageHover?.classList.add('opacity-1')
              videoHover?.play()
              videoHover?.classList.remove('invisible', 'opacity-0')
              videoHover?.classList.add('opacity-1')
            })
            product.addEventListener('mouseout', () => {
              product.classList.remove('text-white')
              image.classList.remove('hidden')
              icon.classList.add('hidden', 'opacity-0')
              imageHover?.classList.add('visible', 'opacity-0')
              imageHover?.classList.add('opacity-0')
              videoHover?.pause()
              videoHover?.classList.add('invisible', 'opacity-0')
            })
          })
        })
      }
    },
  )
}
